var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-layout"},[_c('main-header',{on:{"region-change":_vm.handleRegionChange}}),_c('router-view',{key:_vm.$route.fullPath,attrs:{"newAlarmCount":_vm.newAlarmCount,"selected-region":_vm.selectedRegion},on:{"child":_vm.refreshAlarm}}),_c('main-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }